import React, { useState, useRef } from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import { LayoutSingleColumn, LayoutWrapperTopbar, LayoutWrapperMain, LayoutWrapperFooter, Footer } from '../../components';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import css from './HowLoyalIsMyPartnerQuizPage.module.css';

// Using images from public directory
const menCheatImage = '/static/images/blog/why-do-men-cheat.jpg';
const testBoyfriendImage = '/static/images/blog/test-boyfriend.jpg';
const ariProfileImage = '/static/images/blog/Ari_loyalty_tester.png';

const HowLoyalIsMyPartnerQuizPage = () => {
  const [answers, setAnswers] = useState({});
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const resultRef = useRef(null);

  const questions = [
    {
      id: 1,
      question: "How does your partner communicate with you?",
      options: [
        { text: "Always open and honest", score: 3 },
        { text: "Usually honest", score: 2 },
        { text: "Sometimes secretive", score: 1 },
        { text: "Often secretive", score: 0 }
      ]
    },
    {
      id: 2,
      question: "How does your partner handle their phone?",
      options: [
        { text: "Always leaves it around", score: 3 },
        { text: "Usually leaves it around", score: 2 },
        { text: "Often keeps it hidden", score: 1 },
        { text: "Always keeps it hidden", score: 0 }
      ]
    },
    {
      id: 3,
      question: "How does your partner spend their free time?",
      options: [
        { text: "Mostly with me", score: 3 },
        { text: "Balanced between us and others", score: 2 },
        { text: "Often without me", score: 1 },
        { text: "Almost always without me", score: 0 }
      ]
    },
    {
      id: 4,
      question: "How does your partner handle social media?",
      options: [
        { text: "Open about all accounts", score: 3 },
        { text: "Shares most accounts", score: 2 },
        { text: "Secretive about some accounts", score: 1 },
        { text: "Very secretive about accounts", score: 0 }
      ]
    },
    {
      id: 5,
      question: "How does your partner handle their past?",
      options: [
        { text: "Completely open about past", score: 3 },
        { text: "Shares when asked", score: 2 },
        { text: "Vague about past", score: 1 },
        { text: "Secretive about past", score: 0 }
      ]
    },
    {
      id: 6,
      question: "How does your partner handle jealousy?",
      options: [
        { text: "Very understanding", score: 3 },
        { text: "Generally understanding", score: 2 },
        { text: "Sometimes dismissive", score: 1 },
        { text: "Often dismissive", score: 0 }
      ]
    },
    {
      id: 7,
      question: "How does your partner handle boundaries?",
      options: [
        { text: "Always respects boundaries", score: 3 },
        { text: "Usually respects boundaries", score: 2 },
        { text: "Sometimes crosses boundaries", score: 1 },
        { text: "Often crosses boundaries", score: 0 }
      ]
    },
    {
      id: 8,
      question: "How does your partner handle commitment?",
      options: [
        { text: "Fully committed", score: 3 },
        { text: "Generally committed", score: 2 },
        { text: "Sometimes hesitant", score: 1 },
        { text: "Often hesitant", score: 0 }
      ]
    },
    {
      id: 9,
      question: "How does your partner handle trust?",
      options: [
        { text: "Always trustworthy", score: 3 },
        { text: "Usually trustworthy", score: 2 },
        { text: "Sometimes untrustworthy", score: 1 },
        { text: "Often untrustworthy", score: 0 }
      ]
    },
    {
      id: 10,
      question: "Has your partner cheated in past relationships?",
      options: [
        { text: "No, never cheated", score: 3 },
        { text: "Once, but deeply regrets it", score: 2 },
        { text: "Multiple times in past", score: 1 },
        { text: "Refuses to discuss past", score: 0 }
      ]
    },
    {
      id: 11,
      question: "How does your partner handle their social life?",
      options: [
        { text: "Includes me in social events", score: 3 },
        { text: "Sometimes includes me", score: 2 },
        { text: "Often excludes me", score: 1 },
        { text: "Always excludes me", score: 0 }
      ]
    },
    {
      id: 12,
      question: "Does your partner show interest in your life?",
      options: [
        { text: "Very interested and engaged", score: 3 },
        { text: "Generally interested", score: 2 },
        { text: "Sometimes interested", score: 1 },
        { text: "Rarely interested", score: 0 }
      ]
    },
    {
      id: 13,
      question: "How does your partner handle their work-life balance?",
      options: [
        { text: "Balances well with relationship", score: 3 },
        { text: "Sometimes prioritizes work", score: 2 },
        { text: "Often prioritizes work", score: 1 },
        { text: "Always prioritizes work", score: 0 }
      ]
    },
    {
      id: 14,
      question: "Does your partner keep their promises?",
      options: [
        { text: "Always keeps promises", score: 3 },
        { text: "Usually keeps promises", score: 2 },
        { text: "Sometimes breaks promises", score: 1 },
        { text: "Often breaks promises", score: 0 }
      ]
    },
    {
      id: 15,
      question: "How does your partner handle their past mistakes?",
      options: [
        { text: "Takes full responsibility", score: 3 },
        { text: "Usually takes responsibility", score: 2 },
        { text: "Sometimes takes responsibility", score: 1 },
        { text: "Never takes responsibility", score: 0 }
      ]
    }
  ];

  const handleAnswer = (questionId, score) => {
    setAnswers({ ...answers, [questionId]: score });
  };

  const calculateResult = () => {
    const totalScore = Object.values(answers).reduce((sum, score) => sum + score, 0);
    setScore(totalScore);
    setShowResult(true);
    // Scroll to result container
    setTimeout(() => {
      resultRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  const getResultMessage = () => {
    if (score >= 35) {
      return {
        title: "Your Partner Shows Strong Loyalty",
        message: "Based on your answers, your partner demonstrates strong loyalty and commitment to your relationship. Keep nurturing your bond!",
        showTest: false
      };
    } else if (score >= 20) {
      return {
        title: "Some Concerns About Loyalty",
        message: "Your answers suggest there might be some concerns about your partner's loyalty. Consider having an open conversation about your feelings.",
        showTest: true
      };
    } else {
      return {
        title: "Significant Loyalty Concerns",
        message: "Your answers indicate serious concerns about your partner's loyalty. It might be time to consider a professional loyalty test to get clarity.",
        showTest: true
      };
    }
  };

  const result = getResultMessage();

  const relatedArticles = [
    {
      id: 1,
      title: 'What I Learned from a Loyalty Test on My (Ex)Husband',
      description: 'Is your partner staying faithful? Learn how I set up a loyalty test to catch a cheating spouse and gain closure.',
      image: ariProfileImage,
      link: '/what-i-learned-from-loyalty-test'
    },
    {
      id: 2,
      title: 'Why Do Men Cheat?',
      description: 'Understand the psychology behind infidelity and what drives men to cheat in relationships.',
      image: menCheatImage,
      link: '/WhyDoMenCheat'
    },
    {
      id: 3,
      title: 'How to Test Your Boyfriend (Without Hurting Your Relationship)',
      description: 'Learn to recognize the subtle and obvious signs that could indicate infidelity in your relationship.',
      image: testBoyfriendImage,
      link: '/how-to-test-your-boyfriend'
    }
  ];

  return (
    <StaticPage
      title="How Loyal Is My Partner? - Take the Quiz"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: 'Take this comprehensive quiz to assess your partner\'s loyalty and get personalized recommendations based on your answers.',
        name: 'How Loyal Is My Partner Quiz',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <Helmet>
            <meta name="keywords" content="loyalty test, relationship quiz, partner loyalty, relationship advice, loyalty assessment" />
            <link rel="canonical" href="https://loyalty-test.com/how-loyal-is-my-partner-quiz" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="How Loyal Is My Partner? - Take the Quiz" />
            <meta property="og:description" content="Take this comprehensive quiz to assess your partner's loyalty and get personalized recommendations based on your answers." />
            <meta property="og:image" content="/static/images/blog/what-does-loyalty-in-relationships-look-like-1.jpg" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="How Loyal Is My Partner? - Take the Quiz" />
            <meta name="twitter:description" content="Take this comprehensive quiz to assess your partner's loyalty and get personalized recommendations based on your answers." />
            <meta name="twitter:image" content="/static/images/blog/what-does-loyalty-in-relationships-look-like-1.jpg" />
          </Helmet>

          <h1 className={css.pageTitle}>How Loyal Is My Partner? - Take the Quiz</h1>
          
          <div className={css.topInfoBar}>
            <div className={css.rowC}>
              <div className={css.profileIcon}>
                <span className={css.initials}>JS</span>
              </div>
              <div>
                <div className={css.topInfoLine}>
                  <Link to="/writers/jessica-shouland" className={css.author}>By Jessica Shouland</Link>
                </div>
                <div className={css.bottomInfoLine}>
                  <span>Published: March 28th, 2025</span>
                  <span>•</span>
                  <span>5 min read</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className={css.contentWrapper}>
            <p>Ever wonder about your partner's loyalty? It's a question that can keep you tossing at night, but understanding where you stand is the first step toward fostering a stronger relationship together. This quiz has 15 loyalty test questions to give you a general idea of where your partner stands. Ready to get some answers? Let's dive in.</p>

            {!showResult ? (
              <div className={css.quizContainer}>
                {questions.map(question => (
                  <div key={question.id} className={css.questionContainer}>
                    <h3 className={css.question}>Question {question.id}: {question.question}</h3>
                    <div className={css.options}>
                      {question.options.map((option, index) => (
                        <button
                          key={index}
                          className={`${css.option} ${answers[question.id] === option.score ? css.selected : ''}`}
                          onClick={() => handleAnswer(question.id, option.score)}
                        >
                          {option.text}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
                <button 
                  className={css.submitButton}
                  onClick={calculateResult}
                  disabled={Object.keys(answers).length !== questions.length}
                >
                  Get Your Results
                </button>
              </div>
            ) : (
              <div className={css.resultContainer} ref={resultRef}>
                <h2 className={css.resultTitle}>{result.title}</h2>
                <p className={css.resultMessage}>{result.message}</p>
                
                <div className={css.testRecommendation}>
                  <p>If you are still unsure about your partner's loyalty, Loyalty-Test.com offers vetted and discreet testers to answer that question. Hire an actress, model, or influencer to DM and flirt with your partner today.</p>
                  <Link to="/" className={css.testButton}>
                    Loyalty Test Your Partner Today
                  </Link>
                </div>
              </div>
            )}
          </div>

          <div className={css.relatedArticles}>
            <h2>Related Articles</h2>
            <div className={css.relatedArticlesGrid}>
              {relatedArticles.map(article => (
                <Link 
                  key={article.id} 
                  to={article.link}
                  className={css.relatedArticleCard}
                >
                  <img 
                    src={article.image} 
                    alt={article.title} 
                    className={css.relatedArticleImage} 
                    loading="lazy"
                    width="300"
                    height="180"
                  />
                  <div className={css.relatedArticleContent}>
                    <h3 className={css.relatedArticleTitle}>{article.title}</h3>
                    <p className={css.relatedArticleDescription}>{article.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HowLoyalIsMyPartnerQuizPage; 